import React, { useEffect, useState } from "react";
import { Button, Space, Modal, Typography, Table, Tooltip } from "antd";
import {
  PrinterOutlined,
  DownloadOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";
import { FormattedMessage } from "react-intl";
import { setHeader } from "../../../components/print/printSections/reports";
import { exportEmergencyBtlToPdf } from "../../../components/util/helpers";
import { CSVLink } from "react-csv";
import { useIntl } from "react-intl";
import { CloseOutlined } from "@ant-design/icons";
import moment from "moment";
const { Title, Text } = Typography;

const EmergencyFailedRowsModal = (props) => {
  const { data, headers, onDecline } = props;
  const [items, setItems] = useState([]);
  const intl = useIntl();
  useEffect(() => {
    let arr = [];
    if (data && data.length > 0) {
      data.forEach((val, index) => {
        let temp = {};
        headers.forEach((item, i) => {
          temp[item] = val["Row"][i];
        });
        arr.push(temp);
      });
    }
    setItems(arr);
  }, [data, headers]);

  const onPrint = async (action) => {
    const headerRecord = {
      name: intl.formatMessage({
        id: "app.patients.emergency_btl_unrecognized_title",
      }),
    };
    exportEmergencyBtlToPdf(
      "emergency_details_unrecognized_patients",
      items,
      headers,
      setHeader,
      headerRecord,
      {
        styles: { fontSize: 7 },
        margin: { top: 26 },
      },
      action
    );
  };

  const columns = headers.map((col) => {
    return {
      title: col,
      dataIndex: col,
      render(text, record) {
        return (
          <Tooltip className="content" placement="topLeft" title={text}>
            <Text ellipsis={true}>{text}</Text>
          </Tooltip>
        );
      },
    };
  });

  return (
    <Modal
      width={"vw"}
      style={{
        height: "100vh",
        maxWidth: "100vw",
        position: "absolute",
        top: 0,
        left: 0,
      }}
      styles={{
        body: {
          height: "100vh",
          width: "100vw",
          padding: "0 24px",
        },
      }}
      closable={false}
      open={data.length > 0}
      footer={null}
      destroyOnClose={true}
    >
      <div>
        <div className="header" style={{ height: "40px" }}>
          <Button
            style={{ position: "absolute", right: 10, top: 10 }}
            className="closeBtn"
            type="text"
            shape="circle"
            icon={<CloseOutlined />}
            onClick={onDecline}
          />
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Title>
            {intl.formatMessage({
              id: "app.patients.emergency_btl_unrecognized_title",
            })}
          </Title>
          <Space>
            <Button icon={<PrinterOutlined />} onClick={() => onPrint("print")}>
              {" "}
              {<FormattedMessage id="app.actions.print" />}
            </Button>
            <Button icon={<DownloadOutlined />} onClick={() => onPrint("save")}>
              {" "}
              {<FormattedMessage id="app.actions.save" />}
            </Button>
            <CSVLink
              data={items}
              headers={headers}
              filename={`${"emergency_details_unrecognized_patients"}-${moment().format(
                "HH:mm DD/MM/YYYY"
              )}.csv`}
            >
              <Button icon={<FileExcelOutlined />}>
                {" "}
                {<FormattedMessage id="app.actions.export_to_excel" />}
              </Button>
            </CSVLink>
          </Space>
        </div>

        <Table
          bordered
          rowKey={(record) => record.id}
          columns={columns}
          dataSource={items}
          pagination={false}
          scroll={{ y: window.innerHeight - 400 }}
        />
      </div>
    </Modal>
  );
};

export default EmergencyFailedRowsModal;
